import { DomainApiModel } from '../../../types/models/domain.model';
import { CreateDomainApiRequest } from '../../../types/requests/domains/create-domain.request';
import { DeleteDomainApiRequest } from '../../../types/requests/domains/delete-domain.request';
import { GetDomainApiRequest } from '../../../types/requests/domains/get-domain.request';
import { SearchDomainsApiRequest } from '../../../types/requests/domains/search-domains.request';
import { UpdateDomainApiRequest } from '../../../types/requests/domains/update-domain.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const createDomain = (params: CreateDomainApiRequest) => client.post<DomainApiModel>('/domains', params);

export const updateDomain = ({ domainId, ...params }: UpdateDomainApiRequest) =>
  client.patch<DomainApiModel>(`/domains/${domainId}`, params);

export const getDomain = <T extends DomainApiModel>({ domainId }: GetDomainApiRequest) =>
  client.get<T>(`/domains/${domainId}`);

export const searchDomains = (params: SearchDomainsApiRequest) =>
  client.get<CursorPaginatedApiResponse<DomainApiModel>>(`/domains`, { params });

export const deleteDomain = ({ domainId }: DeleteDomainApiRequest) => client.delete<void>(`/domains/${domainId}`);
